import { useEffect, useState } from "react";
import { PipecatClient } from "@pipecat-ai/client-js";
import {
    PipecatClientAudio,
    PipecatClientProvider,
} from "@pipecat-ai/client-react";
import { SmallWebRTCTransport } from "@pipecat-ai/small-webrtc-transport";
import { ConversationProvider } from "@pipecat-ai/voice-ui-kit";
import { VoiceAssistant } from "@/components/VoiceAssistant";
import { applyInvestigatorToolResult } from "@/components/official-statement-store";
import { getIceServers, loadRuntimeConfig } from "@/config";

function createPipecatClient() {
    return new PipecatClient({
        transport: new SmallWebRTCTransport({
            iceServers: getIceServers(),
        }),
        enableCam: false,
        enableMic: true,
        callbacks: {
            onLLMFunctionCallStopped: function (data) {
                applyInvestigatorToolResult(data.result);
            },
        },
    });
}

export function App() {
    const [pcClient, setPcClient] = useState<PipecatClient | null>(null);

    useEffect(function () {
        let canceled = false;

        async function configureClient() {
            await loadRuntimeConfig();

            if (!canceled) {
                setPcClient(createPipecatClient());
            }
        }

        void configureClient();

        return function cleanup() {
            canceled = true;
        };
    }, []);

    if (!pcClient) {
        return <div className="h-dvh bg-zinc-50" />;
    }

    return (
        <PipecatClientProvider client={pcClient}>
            <ConversationProvider>
                <VoiceAssistant />
                <PipecatClientAudio />
            </ConversationProvider>
        </PipecatClientProvider>
    );
}
